/** 列表类 SKU 模块是否有有效表单数据（platform 层使用，不依赖 capabilities） */

function hasNonEmptyString(value: unknown): boolean {
  return typeof value === 'string' && value.trim() !== '';
}

/** dataDisks 数组是否含至少一块有效数据盘 */
export function hasConfiguredDataDiskFormData(raw: unknown): boolean {
  if (!Array.isArray(raw)) return false;
  return raw.some((item) => {
    if (!item || typeof item !== 'object') return false;
    return hasNonEmptyString((item as { diskName?: unknown }).diskName);
  });
}

function isConfiguredContainerVolumeItem(item: unknown): boolean {
  if (!item || typeof item !== 'object') return false;
  const record = item as Record<string, unknown>;
  const volumeName = String(record.volumeName ?? '').trim();
  if (!volumeName) return false;

  if (record.storageClass != null) {
    return hasNonEmptyString(record.storageClass);
  }
  if (record.selected != null) {
    return hasNonEmptyString(record.selected);
  }
  return false;
}

/** volumes 数组是否含至少一条已配置的容器卷 */
export function hasConfiguredContainerVolumeFormData(raw: unknown): boolean {
  if (!Array.isArray(raw)) return false;
  return raw.some(isConfiguredContainerVolumeItem);
}
